export default "__VITE_ASSET__C4_sHth5__"